module.exports = __webpack_public_path__ + "static/head2-9a88788f909c042c62117a305dd95215.jpg";